import angular from 'angular';

angular.module('AaApp.Opp').constant('messageTypes', {
    success: 'success',
    warning: 'warning',
    error: 'error'
});
